// extracted by mini-css-extract-plugin
export var wordContainer = "_nq-0";